import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

const prepareUsers = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.uuid,
      id: item.uuid,
      uuid: item.uuid,
      name: item.name,
      avatar_url: item.avatar_url,
      social_accounts: item.social_accounts,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getGroup({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.get, id, signal });

    yield put(actions.getGroupDone(data.result));

    onSuccess && onSuccess({
      id: data.result.id,
      name: data.result.name,
      users: prepareUsers(data.result.users)
    });
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getGroupFailed,
      endpoint: api.modifiers.regularusers.get.url
    });
  }
}

function* updateGroup({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.update, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.updateGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updateGroupFailed,
      handledErrors,
      endpoint: api.modifiers.regularusers.update.url
    });
  }
}

export const getGroupSaga = takeEvery(types.GET_GROUP_REQUEST, getGroup);
export const updateGroupSaga = takeEvery(types.UPDATE_GROUP_REQUEST, updateGroup);